import { ChangeEvent } from 'react';
import { Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import testingConstants from 'utils/testingConstants';

import { slugifyExtended } from './AliasField/utils';
import RoomNameInput from './RoomNameInput';
import useCreateNewRoomDataContext from '../CreateNewRoomDataProvider/useCreateNewRoomDataContext';

interface RoomNameFieldProps {
  shouldSyncAlias?: boolean;
}

const RoomNameField = ({ shouldSyncAlias = false }: RoomNameFieldProps) => {
  const { t } = useTranslation();
  const { roomForm, hasAliasChanged } = useCreateNewRoomDataContext();

  const {
    setValue,
    control,
    formState: { errors },
  } = roomForm;

  return (
    <Controller
      name="roomName"
      control={control}
      render={({ field: { onChange, value } }) => {
        const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
          if (!hasAliasChanged && shouldSyncAlias) {
            setValue('roomAlias', slugifyExtended(e.target.value), { shouldDirty: true });
          }
          onChange(e.target.value);
        };

        return (
          <RoomNameInput
            value={value}
            onChange={handleChange}
            errorMessage={errors.roomName?.message}
            placeholder={t('room_name')}
            dataTestId={testingConstants.roomTitle}
          />
        );
      }}
    />
  );
};

export default RoomNameField;
